export default "__VITE_ASSET__zuD3G9gA__"